module.exports = __webpack_public_path__ + "static/assets/5243e65e6a2f5b9e50958ed69b85104d.svg";